import flatten from 'lodash/flatten';
import toPairs from 'lodash/toPairs';
import {humanLowerToUpper, accessorials} from '~/misc/equipment';

const formatEquipment = (eqs) =>
  flatten(
    toPairs(eqs)
      .filter(([eq]) => humanLowerToUpper[eq])
      .map(([eq, accs]) =>
        accs.length ? accs.map(i => `${humanLowerToUpper[eq]} ${accessorials[i]}`) : [humanLowerToUpper[eq]]
      )
  ).join('; ');

export default formatEquipment;



// WEBPACK FOOTER //
// ./src/components/search/results/formatEquipment.js